import { provide, reactive } from 'vue';
import Pagination from './pagination.vue';

function usePage({ pageNum = 1, pageSize = 10, totalCount = 0 } = {}) {
  const page = reactive({
    pageNum,
    pageSize,
    totalCount,
  });
  return page;
}

function useQueryPage({ pageNum = 1, pageSize = 10, totalCount = 0 } = {}) {
  const page = reactive({
    pageNum,
    pageSize,
    totalCount,
  });

  const params = reactive({});

  let onQueryFn;

  provide('useQueryPage-query-group', (newParams, changeType) => {
    if (changeType === 'reset') {
      page.pageNum = 1;
    }
    // 点查询,若条件不一样,也重置到第一页.
    if (changeType === 'query' && JSON.stringify(newParams) !== JSON.stringify(params)) {
      page.pageNum = 1;
    }
    Object.assign(params, newParams);
    if (typeof onQueryFn === 'function') {
      onQueryFn(params, changeType);
    }
  });
  provide('useQueryPage-pagination', (newPage) => {
    Object.assign(page, newPage);
    if (typeof onQueryFn === 'function') {
      onQueryFn(params, 'page');
    }
  });

  return {
    page,
    onQuery: (callback) => {
      onQueryFn = callback;
    },
    params,
  };
}

export default {
  install(application) {
    application.provide('usePage', usePage);
    application.provide('useQueryPage', useQueryPage);
    application.component('yx-pagination', Pagination);
  },
};
